'use strict';

var React = require('react'),
    ReactDocumentTitle = require('react-document-title'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var DocumentTitle = React.createClass({
  mixins: [PureRenderMixin],

  render() {
    var title = this.props.title;
    if (!title) {
      title = 'Stampsy';
    } else {
      title += ' · Stampsy';
    }

    return (
      <ReactDocumentTitle title={title}>
        {this.props.children}
      </ReactDocumentTitle>
    );
  }
});

module.exports = DocumentTitle;


/** WEBPACK FOOTER **
 ** ./atoms/DocumentTitle.jsx
 **/